import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/ocean32.dcpltechnology.com/src/components/pages/blog/index.jsx");
